import { useParams, Navigate } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import Header from "../../partials/header";
import LeftSidebar from "../../partials/leftSidebar";
import UsersTab from "./UsersTab";
import { PROFILE_TYPE } from "../../../helper/globalConstant";

const UsersMain = () => {

  // know the current route slug i.e. dynamic route parameter
  const { entityType } = useParams<{ entityType: string }>();

  // Map the URL slug to use with breadcrumb, button and other UI components.
  const labelMap: Record<string, string> = {
    distributors: "Distributors",
    partners: "Partners",
    technicians: "Technicians",
    users: "Users",
  };

  const currentLabel = labelMap[entityType || "users"] || "Users";

  // to ensure which routes can be accessed by which role
  const sess_user_data = localStorage.getItem("sess_user");
  const userPriority = sess_user_data ? JSON.parse(sess_user_data)?.userProfile?.priority : null;

  const roleToEntityMap: Record<number, string> = {
    [PROFILE_TYPE.SUPER_ADMIN]: "distributors",
    [PROFILE_TYPE.DISTRIBUTOR]: "partners",
    [PROFILE_TYPE.INTEGRATOR]: "technicians",
  };

  const isAuthorized = roleToEntityMap[userPriority] === entityType;

  if (!isAuthorized) {
    return <Navigate to="/admin" replace />;
  }

  // determine the current breadcrumb
  const breadCrumb = [
    {
      label: "Admin",
      path: "/admin",
    },
    {
      label: currentLabel,
      path: `/admin/${entityType}`,
    },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <Header title="" breadCrumb={breadCrumb} />
      <LeftSidebar />
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: 8,
          padding: "0",
        }}
      >
        <Box sx={{ margin: "20px" }} component="main">
          <Stack>
            <Box sx={{ position: "absolute" }}>
              <Typography sx={{ fontSize: "22px" }}>{currentLabel}</Typography>
            </Box>

            <UsersTab entityType={entityType} />

          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default UsersMain;
